import { render } from "./Pdf.vue?vue&type=template&id=b70b46b4&scoped=true"
import script from "./Pdf.vue?vue&type=script&lang=js"
export * from "./Pdf.vue?vue&type=script&lang=js"

import "./Pdf.vue?vue&type=style&index=0&id=b70b46b4&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b70b46b4"]])

export default __exports__